import type { GetFolderQuery, GetFolderQueryVariables } from '@/typings/domain'
import apolloClient from './apolloClient'
import GetFolderGQL from './graphql/GetFolder.graphql'

export function getFolder({ folderToken }: { folderToken: string }) {
  return apolloClient.query<GetFolderQuery, GetFolderQueryVariables>({
    query: GetFolderGQL,
    variables: { folderToken },
    fetchPolicy: 'no-cache',
  })
}
